import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42;

import { normalizePhoneNumber } from "@dp/common";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import * as yup from "yup";
import BrandRules from "../../utils/BrandRules";
var phoneRegExp = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/;
var alphabetRegExp = /^[A-Z'’a-z]+$/;

var _SCHEMA = yup.object({
  updatedUserFirstName: yup.string().max(32, "Max. characters allowed are 32").min(2, "Min. 2 characters required").required("This field is mandatory"),
  newUserEmailAddress: yup.string().email("Please enter a valid email").required("Please enter a valid email"),
  confirmNewUserEmailAddress: yup.string().email("Please enter a valid email").required("Please enter a valid email").oneOf([yup.ref("newUserEmailAddress"), null], "Emails don't match"),
  updatedUserMobileNumber: yup.string().required("Please enter phone number").matches(phoneRegExp, "Phone number is not valid"),
  userLastName: yup.string() // .matches(alphabetRegExp, "Only alphabets are allowed for this field")
  .min(2, "Min. 2 characters required").max(32, "Max. characters allowed are 32").required("This field is mandatory"),
  userNewPassword: yup.string().required("Please enter a value"),
  userConfirmPassword: yup.string().required("Please enter a value").oneOf([yup.ref("userNewPassword"), null], "New Password and Confirm Password should be same."),
  resetPasswordEmailAddress: yup.string().email("Please enter a valid email").required("Please enter a valid email"),
  resetPasswordNewPassword: yup.string().required("Please enter a value"),
  resetPasswordConfirmNewPassword: yup.string().required("Please enter a value").oneOf([yup.ref("resetPasswordNewPassword"), null], "New Password and Confirm Password should be same.")
});

export var ActiveInputField;

(function (ActiveInputField) {
  ActiveInputField[ActiveInputField["FIRST_NAME"] = 0] = "FIRST_NAME";
  ActiveInputField[ActiveInputField["LAST_NAME"] = 1] = "LAST_NAME";
  ActiveInputField[ActiveInputField["MOBILE_NUMBER"] = 2] = "MOBILE_NUMBER";
  ActiveInputField[ActiveInputField["EMAIL"] = 3] = "EMAIL";
  ActiveInputField[ActiveInputField["PASSWORD"] = 4] = "PASSWORD";
  ActiveInputField[ActiveInputField["DOB"] = 5] = "DOB";
})(ActiveInputField || (ActiveInputField = {}));

export var UserProfileModel = (_class = /*#__PURE__*/function () {
  // TODO(LOGIN):: move it to null and set from LOGIN API
  function UserProfileModel() {
    _classCallCheck(this, UserProfileModel);

    _initializerDefineProperty(this, "_updatedUserFirstName", _descriptor, this);

    _initializerDefineProperty(this, "_newUserEmailAddress", _descriptor2, this);

    _initializerDefineProperty(this, "_confirmNewUserEmailAddress", _descriptor3, this);

    _initializerDefineProperty(this, "_updatedUserMobileNumber", _descriptor4, this);

    _initializerDefineProperty(this, "_userLastName", _descriptor5, this);

    _initializerDefineProperty(this, "_userConfirmPassword", _descriptor6, this);

    _initializerDefineProperty(this, "_userNewPassword", _descriptor7, this);

    _initializerDefineProperty(this, "_userSecurityQuestion", _descriptor8, this);

    _initializerDefineProperty(this, "_userSecurityAnswer", _descriptor9, this);

    _initializerDefineProperty(this, "_userDobDay", _descriptor10, this);

    _initializerDefineProperty(this, "_userDobMonth", _descriptor11, this);

    _initializerDefineProperty(this, "_userDobYear", _descriptor12, this);

    _initializerDefineProperty(this, "_resetPasswordEmailAddress", _descriptor13, this);

    _initializerDefineProperty(this, "_resetPasswordNewPassword", _descriptor14, this);

    _initializerDefineProperty(this, "_resetPasswordConfirmNewPassword", _descriptor15, this);

    _initializerDefineProperty(this, "_activeTab", _descriptor16, this);

    _initializerDefineProperty(this, "_showChangeFirstNameModal", _descriptor17, this);

    _initializerDefineProperty(this, "_showChangeLastNameModal", _descriptor18, this);

    _initializerDefineProperty(this, "_showChangeBirthdayModal", _descriptor19, this);

    _initializerDefineProperty(this, "_showChangeMobileNumberModal", _descriptor20, this);

    _initializerDefineProperty(this, "_showEditEmailModal", _descriptor21, this);

    _initializerDefineProperty(this, "_showChangePasswordModal", _descriptor22, this);

    _initializerDefineProperty(this, "_showUpdateQuestionModal", _descriptor23, this);

    _initializerDefineProperty(this, "_showOrderHistoryDescriptionModal", _descriptor24, this);

    _initializerDefineProperty(this, "_isEditingProfile", _descriptor25, this);

    _initializerDefineProperty(this, "_showAddCreditCardView", _descriptor26, this);

    _initializerDefineProperty(this, "_showEditCreditCardView", _descriptor27, this);

    _initializerDefineProperty(this, "_showAddGiftCardView", _descriptor28, this);

    _initializerDefineProperty(this, "_showEditGiftCardView", _descriptor29, this);

    _initializerDefineProperty(this, "_preferredRestaurantDetails", _descriptor30, this);

    _initializerDefineProperty(this, "_isChangeLocationModalOpen", _descriptor31, this);

    _initializerDefineProperty(this, "_orderHistoryDetails", _descriptor32, this);

    _initializerDefineProperty(this, "_inputErrorMsg", _descriptor33, this);

    _initializerDefineProperty(this, "_activeInputField", _descriptor34, this);

    _initializerDefineProperty(this, "_scheduledDOB", _descriptor35, this);

    _initializerDefineProperty(this, "_modalProgress", _descriptor36, this);

    _initializerDefineProperty(this, "_isSocialFlow", _descriptor37, this);

    _initializerDefineProperty(this, "_showPreferredLocationSelectionAfterCreateAccount", _descriptor38, this);

    _initializerDefineProperty(this, "_jwtToken", _descriptor39, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor40, this);

    _initializerDefineProperty(this, "_numberOfActiveReservations", _descriptor41, this);

    _initializerDefineProperty(this, "_subscrpTransferStatus", _descriptor42, this);

    makeObservable(this);
  }

  _createClass(UserProfileModel, [{
    key: "setActiveTab",
    value: function setActiveTab(tab) {
      this._activeTab = tab;
    }
  }, {
    key: "setShowChangeFirstNameModal",
    value: function setShowChangeFirstNameModal(show) {
      this._showChangeFirstNameModal = show;
    }
  }, {
    key: "setShowChangeLastNameModal",
    value: function setShowChangeLastNameModal(show) {
      this._showChangeLastNameModal = show;
    }
  }, {
    key: "setShowChangeMobileNumberModal",
    value: function setShowChangeMobileNumberModal(show) {
      this._showChangeMobileNumberModal = show;
    }
  }, {
    key: "setShowOrderHistoryDescriptionModal",
    value: function setShowOrderHistoryDescriptionModal(show) {
      this._showOrderHistoryDescriptionModal = show;
    }
  }, {
    key: "setOrderHistoryDetails",
    value: function setOrderHistoryDetails(details) {
      this._orderHistoryDetails = details;
    }
  }, {
    key: "setShowChangeBirthday",
    value: function setShowChangeBirthday(show) {
      this._showChangeBirthdayModal = show;
    }
  }, {
    key: "setShowEditEmailModal",
    value: function setShowEditEmailModal(show) {
      this._showEditEmailModal = show;
    }
  }, {
    key: "setShowChangePasswordModal",
    value: function setShowChangePasswordModal(show) {
      this._showChangePasswordModal = show;
    }
  }, {
    key: "setShowUpdateQuestionModal",
    value: function setShowUpdateQuestionModal(show) {
      this._showUpdateQuestionModal = show;
    }
  }, {
    key: "setIsEditingProfile",
    value: function setIsEditingProfile(editing) {
      this._isEditingProfile = editing;
    }
  }, {
    key: "setPreferredRestaurantDetails",
    value: function setPreferredRestaurantDetails(preferredRestaurantDetails) {
      this._preferredRestaurantDetails = preferredRestaurantDetails;
    }
  }, {
    key: "setActiveInputField",
    value: function setActiveInputField(activeInputField) {
      this._activeInputField = activeInputField;
    }
  }, {
    key: "setModalProgress",
    value: function setModalProgress(_ref) {
      var isEditing = _ref.isEditing,
          isConfirming = _ref.isConfirming,
          isCompleted = _ref.isCompleted;
      this._modalProgress = {
        isEditing: isEditing,
        isConfirming: isConfirming,
        isCompleted: isCompleted
      };
    }
  }, {
    key: "setInputErrorMsg",
    value: function setInputErrorMsg(inputErrorMsg) {
      this._inputErrorMsg = inputErrorMsg;
    }
  }, {
    key: "setJwtToken",
    value: function setJwtToken(jwtToken) {
      this._jwtToken = jwtToken;
    }
  }, {
    key: "setScheduledDOB",
    value: function setScheduledDOB(scheduledDOB) {
      this._scheduledDOB = scheduledDOB;
    }
  }, {
    key: "resetModals",
    value: function resetModals() {
      this.setModalProgress({
        isEditing: false,
        isConfirming: false,
        isCompleted: false
      });
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      this._appAttributes = _appAttributes;
    }
  }, {
    key: "resetValues",
    value: function resetValues() {
      var _this = this;

      runInAction(function () {
        _this._updatedUserFirstName = "";
        _this._updatedUserMobileNumber = "";
        _this._newUserEmailAddress = "";
        _this._confirmNewUserEmailAddress = "";
        _this._userLastName = "";
        _this._userNewPassword = "";
        _this._userConfirmPassword = "";
        _this._userSecurityQuestion = "";
        _this._userSecurityAnswer = "";
        _this._userDobDay = "";
        _this._userDobMonth = "";
        _this._userDobYear = "";
        _this._resetPasswordEmailAddress = "";
        _this._resetPasswordNewPassword = "";
        _this._resetPasswordConfirmNewPassword = "";
        _this._showAddCreditCardView = false;
        _this._showEditCreditCardView = false;
        _this._showAddGiftCardView = false;
        _this._showEditGiftCardView = false;
        _this._inputErrorMsg = null;
        _this._scheduledDOB = null;
        _this._subscrpTransferStatus = false;
      });
    }
  }, {
    key: "setNumberOfActiveReservations",
    value: function setNumberOfActiveReservations(value) {
      this._numberOfActiveReservations = value;
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "isChangeLocationModalOpen",
    get: function get() {
      return this._isChangeLocationModalOpen;
    },
    set: function set(value) {
      var _this2 = this;

      runInAction(function () {
        _this2._isChangeLocationModalOpen = value;
      });
    }
  }, {
    key: "updatedUserFirstName",
    get: function get() {
      return this._updatedUserFirstName;
    },
    set: function set(userFirstName) {
      var _this3 = this; // if (userFirstName && !isAlphaOrContainsSpace(userFirstName)) {
      //   return;
      // }


      runInAction(function () {
        _this3._updatedUserFirstName = userFirstName;
      });
    }
  }, {
    key: "newUserEmailAddress",
    get: function get() {
      return this._newUserEmailAddress;
    },
    set: function set(userEmailAddress) {
      var _this4 = this;

      runInAction(function () {
        _this4._newUserEmailAddress = userEmailAddress;
      });
    }
  }, {
    key: "confirmNewUserEmailAddress",
    get: function get() {
      return this._confirmNewUserEmailAddress;
    },
    set: function set(confirmUserEmailAddress) {
      var _this5 = this;

      runInAction(function () {
        _this5._confirmNewUserEmailAddress = confirmUserEmailAddress;
      });
    }
  }, {
    key: "trimPhoneNumber",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      return ["yh"].includes((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.concept) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.conceptCode.toLowerCase());
    }
  }, {
    key: "updatedUserMobileNumber",
    get: function get() {
      return this._updatedUserMobileNumber;
    },
    set: function set(mobileNumber) {
      var _this6 = this;

      var newPhoneNumber = normalizePhoneNumber(mobileNumber, this._updatedUserMobileNumber);
      runInAction(function () {
        _this6._updatedUserMobileNumber = !_this6.trimPhoneNumber ? newPhoneNumber : newPhoneNumber.replace(" ", "");
      });
    }
  }, {
    key: "userLastName",
    get: function get() {
      return this._userLastName;
    },
    set: function set(value) {
      var _this7 = this;

      runInAction(function () {
        _this7._userLastName = value;
      });
    }
  }, {
    key: "userConfirmPassword",
    get: function get() {
      return this._userConfirmPassword;
    },
    set: function set(value) {
      var _this8 = this;

      runInAction(function () {
        _this8._userConfirmPassword = value;
      });
    }
  }, {
    key: "userNewPassword",
    get: function get() {
      return this._userNewPassword;
    },
    set: function set(value) {
      var _this9 = this;

      runInAction(function () {
        _this9._userNewPassword = value;
      });
    }
  }, {
    key: "userSecurityQuestion",
    get: function get() {
      return this._userSecurityQuestion;
    },
    set: function set(value) {
      var _this10 = this;

      runInAction(function () {
        _this10._userSecurityQuestion = value;
      });
    }
  }, {
    key: "userSecurityAnswer",
    get: function get() {
      return this._userSecurityAnswer;
    },
    set: function set(value) {
      var _this11 = this;

      runInAction(function () {
        _this11._userSecurityAnswer = value;
      });
    }
  }, {
    key: "userDobDay",
    get: function get() {
      return this._userDobDay;
    },
    set: function set(value) {
      var _this12 = this;

      runInAction(function () {
        _this12._userDobDay = value;
      });
    }
  }, {
    key: "userDobMonth",
    get: function get() {
      return this._userDobMonth;
    },
    set: function set(value) {
      var _this13 = this;

      runInAction(function () {
        _this13._userDobMonth = value;
      });
    }
  }, {
    key: "userDobYear",
    get: function get() {
      return this._userDobYear;
    },
    set: function set(value) {
      var _this14 = this;

      runInAction(function () {
        _this14._userDobYear = value;
      });
    }
  }, {
    key: "resetPasswordEmailAddress",
    get: function get() {
      return this._resetPasswordEmailAddress;
    },
    set: function set(value) {
      var _this15 = this;

      runInAction(function () {
        _this15._resetPasswordEmailAddress = value;
      });
    }
  }, {
    key: "resetPasswordNewPassword",
    get: function get() {
      return this._resetPasswordNewPassword;
    },
    set: function set(value) {
      var _this16 = this;

      runInAction(function () {
        _this16._resetPasswordNewPassword = value;
      });
    }
  }, {
    key: "resetPasswordConfirmNewPassword",
    get: function get() {
      return this._resetPasswordConfirmNewPassword;
    },
    set: function set(value) {
      var _this17 = this;

      runInAction(function () {
        _this17._resetPasswordConfirmNewPassword = value;
      });
    }
  }, {
    key: "activeTab",
    get: function get() {
      return this._activeTab;
    }
  }, {
    key: "showChangeFirstNameModal",
    get: function get() {
      return this._showChangeFirstNameModal;
    }
  }, {
    key: "showChangeLastNameModal",
    get: function get() {
      return this._showChangeLastNameModal;
    }
  }, {
    key: "showChangeMobileNumberModal",
    get: function get() {
      return this._showChangeMobileNumberModal;
    }
  }, {
    key: "showOrderHistoryDescriptionModal",
    get: function get() {
      return this._showOrderHistoryDescriptionModal;
    }
  }, {
    key: "orderHistoryDetails",
    get: function get() {
      return this._orderHistoryDetails;
    }
  }, {
    key: "showChangeDateOfBirthModal",
    get: function get() {
      return this._showChangeBirthdayModal;
    }
  }, {
    key: "showEditEmailModal",
    get: function get() {
      return this._showEditEmailModal;
    }
  }, {
    key: "showChangePasswordModal",
    get: function get() {
      return this._showChangePasswordModal;
    }
  }, {
    key: "showUpdateQuestionModal",
    get: function get() {
      return this._showUpdateQuestionModal;
    }
  }, {
    key: "isEditingProfile",
    get: function get() {
      return this._isEditingProfile;
    }
  }, {
    key: "showAddCreditCardView",
    get: function get() {
      return this._showAddCreditCardView;
    },
    set: function set(_showAddCreditCardView) {
      var _this18 = this;

      runInAction(function () {
        _this18._showAddCreditCardView = _showAddCreditCardView;
      });
    }
  }, {
    key: "showEditCreditCardView",
    get: function get() {
      return this._showEditCreditCardView;
    },
    set: function set(_showEditCreditCardView) {
      var _this19 = this;

      runInAction(function () {
        _this19._showEditCreditCardView = _showEditCreditCardView;
      });
    }
  }, {
    key: "showAddGiftCardView",
    get: function get() {
      return this._showAddGiftCardView;
    },
    set: function set(_showAddGiftCardView) {
      var _this20 = this;

      runInAction(function () {
        _this20._showAddGiftCardView = _showAddGiftCardView;
      });
    }
  }, {
    key: "showEditGiftCardView",
    get: function get() {
      return this._showEditGiftCardView;
    },
    set: function set(_showEditGiftCardView) {
      var _this21 = this;

      runInAction(function () {
        _this21._showEditGiftCardView = _showEditGiftCardView;
      });
    }
  }, {
    key: "preferredRestaurantDetails",
    get: function get() {
      return this._preferredRestaurantDetails;
    }
  }, {
    key: "activeInputField",
    get: function get() {
      return this._activeInputField;
    }
  }, {
    key: "modalProgress",
    get: function get() {
      return this._modalProgress;
    }
  }, {
    key: "inputErrorMsg",
    get: function get() {
      return this._inputErrorMsg;
    }
  }, {
    key: "jwtToken",
    get: function get() {
      return this._jwtToken;
    }
  }, {
    key: "scheduledDOB",
    get: function get() {
      return this._scheduledDOB;
    }
  }, {
    key: "isSocialFlow",
    get: function get() {
      return this._isSocialFlow;
    },
    set: function set(_isSocialFlow) {
      var _this22 = this;

      runInAction(function () {
        _this22._isSocialFlow = _isSocialFlow;
      });
    }
  }, {
    key: "showPreferredLocationSelectionAfterCreateAccount",
    get: function get() {
      return this._showPreferredLocationSelectionAfterCreateAccount;
    },
    set: function set(_showPreferredLocationSelectionAfterCreateAccount) {
      var _this23 = this;

      runInAction(function () {
        _this23._showPreferredLocationSelectionAfterCreateAccount = _showPreferredLocationSelectionAfterCreateAccount;
      });
    }
  }, {
    key: "secondarySignupSources",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3;

      var sourcesString = (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3["orderconf-secondary-signup"];
      var sources = sourcesString === null || sourcesString === void 0 ? void 0 : sourcesString.split(",");

      if (sources) {
        return sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
          var _source, _brandNameRegex$exec;

          source = (_source = source) === null || _source === void 0 ? void 0 : _source.replace(/["']/g, "");
          var brandNameRegex = /general-(.*)-[lL]ogo/;
          var brandName = (_brandNameRegex$exec = brandNameRegex.exec(source)) === null || _brandNameRegex$exec === void 0 ? void 0 : _brandNameRegex$exec[1];
          return {
            clubName: source,
            imageName: "".concat(brandName, "-club")
          };
        });
      }

      return [];
    }
  }, {
    key: "isReservationEnabledOnSite",
    get: function get() {
      var _this$_appAttributes4, _this$_appAttributes5;

      return (this === null || this === void 0 ? void 0 : (_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.configs) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.reservationEnabled) === "true" ? true : false;
    }
  }, {
    key: "activeReservations",
    get: function get() {
      return this._numberOfActiveReservations;
    }
  }, {
    key: "hideBGImageOnAccountScreens",
    get: function get() {
      var _this$_appAttributes6;

      return new BrandRules((_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.currentConceptCode).hideBGImageOnAccountScreens();
    }
  }, {
    key: "subscrpTransferStatus",
    get: function get() {
      return this._subscrpTransferStatus;
    },
    set: function set(val) {
      var _this24 = this;

      runInAction(function () {
        _this24._subscrpTransferStatus = val;
      });
    }
  }]);

  return UserProfileModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_updatedUserFirstName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_newUserEmailAddress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_confirmNewUserEmailAddress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_updatedUserMobileNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_userLastName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_userConfirmPassword", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_userNewPassword", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_userSecurityQuestion", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_userSecurityAnswer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_userDobDay", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_userDobMonth", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_userDobYear", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_resetPasswordEmailAddress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_resetPasswordNewPassword", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_resetPasswordConfirmNewPassword", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_activeTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_showChangeFirstNameModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_showChangeLastNameModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_showChangeBirthdayModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_showChangeMobileNumberModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_showEditEmailModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_showChangePasswordModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_showUpdateQuestionModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_showOrderHistoryDescriptionModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_isEditingProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_showAddCreditCardView", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "_showEditCreditCardView", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "_showAddGiftCardView", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "_showEditGiftCardView", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_preferredRestaurantDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "_isChangeLocationModalOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "_orderHistoryDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "_inputErrorMsg", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "_activeInputField", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "_scheduledDOB", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "_modalProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      isEditing: false,
      isConfirming: false,
      isCompleted: false
    };
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "_isSocialFlow", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "_showPreferredLocationSelectionAfterCreateAccount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "_jwtToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "_numberOfActiveReservations", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "_subscrpTransferStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isChangeLocationModalOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isChangeLocationModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatedUserFirstName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "updatedUserFirstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "newUserEmailAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "newUserEmailAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmNewUserEmailAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "confirmNewUserEmailAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trimPhoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "trimPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatedUserMobileNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "updatedUserMobileNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userLastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userLastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userConfirmPassword", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userConfirmPassword"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userNewPassword", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userNewPassword"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userSecurityQuestion", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userSecurityQuestion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userSecurityAnswer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userSecurityAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDobDay", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDobDay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDobMonth", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDobMonth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDobYear", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDobYear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetPasswordEmailAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resetPasswordEmailAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetPasswordNewPassword", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resetPasswordNewPassword"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetPasswordConfirmNewPassword", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resetPasswordConfirmNewPassword"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setActiveTab", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setActiveTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showChangeFirstNameModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showChangeFirstNameModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowChangeFirstNameModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowChangeFirstNameModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showChangeLastNameModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showChangeLastNameModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowChangeLastNameModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowChangeLastNameModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showChangeMobileNumberModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showChangeMobileNumberModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowChangeMobileNumberModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowChangeMobileNumberModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showOrderHistoryDescriptionModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showOrderHistoryDescriptionModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowOrderHistoryDescriptionModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowOrderHistoryDescriptionModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderHistoryDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderHistoryDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOrderHistoryDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOrderHistoryDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showChangeDateOfBirthModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showChangeDateOfBirthModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowChangeBirthday", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowChangeBirthday"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showEditEmailModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showEditEmailModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowEditEmailModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowEditEmailModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showChangePasswordModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showChangePasswordModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowChangePasswordModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowChangePasswordModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showUpdateQuestionModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showUpdateQuestionModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowUpdateQuestionModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowUpdateQuestionModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEditingProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEditingProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsEditingProfile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsEditingProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAddCreditCardView", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAddCreditCardView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showEditCreditCardView", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showEditCreditCardView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAddGiftCardView", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAddGiftCardView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showEditGiftCardView", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showEditGiftCardView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPreferredRestaurantDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPreferredRestaurantDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeInputField", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeInputField"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setActiveInputField", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setActiveInputField"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "modalProgress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "modalProgress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setModalProgress", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setModalProgress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inputErrorMsg", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "inputErrorMsg"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setInputErrorMsg", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setInputErrorMsg"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "jwtToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "jwtToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setJwtToken", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setJwtToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scheduledDOB", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "scheduledDOB"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setScheduledDOB", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setScheduledDOB"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSocialFlow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSocialFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPreferredLocationSelectionAfterCreateAccount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPreferredLocationSelectionAfterCreateAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAppAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAppAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySignupSources", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySignupSources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReservationEnabledOnSite", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReservationEnabledOnSite"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeReservations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeReservations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideBGImageOnAccountScreens", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideBGImageOnAccountScreens"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNumberOfActiveReservations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setNumberOfActiveReservations"), _class.prototype)), _class);